import { combineReducers } from 'redux';

import containerReducer from './ducks/container';
import rootCausesReducer from './ducks/root-causes';

export default combineReducers({
  container: containerReducer,
  rootCauses: rootCausesReducer,
});
